// extracted by mini-css-extract-plugin
export var externalLink = "styles-module--externalLink--tWya6";
export var image = "styles-module--image--z4MGM";
export var imageLink = "styles-module--imageLink--fmJEn";
export var imageBorder = "styles-module--imageBorder--uEJff";
export var video = "styles-module--video--xtq+b";
export var videoContainer = "styles-module--videoContainer--8BPoz";